var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"rounded-lg mt-2",staticStyle:{"overflow-y":"auto"},attrs:{"items":_vm.allInvoices,"headers":_vm.headers,"mobile-breakpoint":"0","hide-default-footer":""},scopedSlots:_vm._u([{key:"item.invoice_id",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'billing/statements/show', params: { invoice_id: item.invoice_id } }}},[_vm._v(" "+_vm._s(item.invoice_id)+" ")])]}},{key:"item.invoice_date",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDateMY(item.invoice_date))+" ")]}},{key:"item.total_cents",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatCurrency(item.total_cents))+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }